import React from "react";
import DurationPickFormField from "../DurationPickFormField";
import { EeCodePickerFormField } from "../EeCodePickerFormField";
import EnumDropdownFormField from "~/visuals/organisms/EnumDropdownFormField";
import { TimeOffTypeLabels } from "~/gql/types";
import "./TimeOffEntryForm.scss";
import Spinner from "~/components/spinner";
import FormBottomRow from "~/components/form-bottom-row";
import FormCard from "~/components/form-card";
import TitleDeleteOption from "~/title-delete-option";
import { AdminNotes } from "../AdminNotes";
import { useRelativeNav } from "~/relative-nav";
import { SaveAndHandler } from "~/WorkDayApi/SaveAndHandler";

export type TimeOffEntryFormProps = {
  type: "Create" | "Edit";
  errorMessage: string | null;
  date: string;
  loading: boolean;
  onDelete?: () => void;
};

const TimeOffEntryForm: React.FC<TimeOffEntryFormProps> = ({
  type,
  errorMessage,
  loading,
  onDelete,
}) => {
  const nav = useRelativeNav();
  const cancelPath = type === "Edit" ? "../../" : "../";

  return (
    <div className="time-off-entry">
      <TitleDeleteOption
        title={`${type === "Edit" ? "Edit" : "Create New"} Time Off Entry`}
        onDelete={onDelete}
      />
      <Spinner open={loading} />
      <FormCard>
        <DurationPickFormField
          formField="hours"
          label="Hours"
          helperText="The hours taken off."
          required
        />
        <EeCodePickerFormField
          label="EE Code"
          formField="eeCode"
          helperText="The ee code applicable to this work. (use up/down arrows and enter key to select suggestions)"
          required
        />
        <EnumDropdownFormField
          label="Type"
          helperText="The type of time off taken. (use up/down arrows and enter key to select suggestions)"
          formField="timeOffType"
          options={TimeOffTypeLabels}
          required
        />
        <AdminNotes />
        <FormBottomRow
          errorMessage={errorMessage}
          buttonText={type === "Create" ? "Create" : "Save"}
          onCancel={() => nav(cancelPath)}
        >
          {type !== "Edit" && <SaveAndHandler includeClone={false} />}
        </FormBottomRow>
      </FormCard>
    </div>
  );
};

export default TimeOffEntryForm;
